module.exports = __webpack_public_path__ + "media/images/regions/Zinder-0adca255f769568e1ca0db164e961567.png";